<main role="main" class="container">
  <div class="row">
    <div class="col-4">
      <app-dual-card [models]="model.participants">
      </app-dual-card>
    </div>
    <div class="col-8">
      <form #messageForm="ngForm">
        <div class="pt-5">
          <div class="form-group">
            <textarea class="form-control" id="newMessage" rows="3" placeholder="Escribe un mensaje..." [(ngModel)]="newMessage" name="newMessage" required>></textarea>
          </div>
          <div class="text-right">
            <button type="button" class="btn btn-primary mb-2" (click)="sendMessage(); messageForm.reset()">Mándalo</button>
          </div>
        </div>
      </form>

      @if (messages) {
        <div class="msg_history mt-5">
          @for (message of messages; track message) {
            @if (model.currentUserId !== message.owner.id) {
              <div class="incoming_msg">
                <div class="incoming_msg_img">
                  @if (!message.owner.profilePictureUrl) {
                    <p>{{message.owner.firstName}}</p>
                  }
                  @if (message.owner.profilePictureUrl) {
                    <img src="{{message.owner.profilePictureUrl}}" alt="{{message.owner.firstName}}">
                  }
                </div>
                <div class="received_msg">
                  <div class="received_withd_msg">
                    <p>
                      {{message.message}}
                    </p>
                    <span class="time_date"> {{message.createdOn}}</span>
                  </div>
                </div>
              </div>
            }
            @if (model.currentUserId === message.owner.id) {
              <div class="outgoing_msg">
                <div class="sent_msg">
                  <p>
                    {{message.message}}
                  </p>
                  <span class="time_date"> {{message.createdOn}}</span>
                </div>
              </div>
            }
          }
        </div>
      } @else {
        <div>Loading...</div>
      }


    </div>
  </div>
</main>